"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textWithHtmlClasses = void 0;
var _mui = require("@ori-ui/mui");
const textWithHtmlClasses = exports.textWithHtmlClasses = (0, _mui.generateUtilityClasses)('TextWithHtml', ['root', 'text', 'toggleButton']);
//# sourceMappingURL=textWithHtmlClasses.js.map